module.exports = __webpack_public_path__ + "static/media/chef.9bfc5c78.jpg";